import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './examples.scss';
// import ajax from '@/api/public';

class Weidai extends React.Component{
	constructor (props) {
		super(props);
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/customer' className="mianbaoxie">客户案例</a><i className='glyphicon glyphicon-toright'></i> <span>微贷网</span>
				</div>
				<div className='common-title' style={{marginBottom: '24px'}}>微贷（杭州）金融信息服务有限公司</div>
				<div className='home-contain text-contain'>
					<span>推广产品名称：微贷网</span>
					<span>推广主题文案：投资理财、p2p理财、微贷网理财</span>
					<span>推广平台：360搜索、360品牌直达、360手机助手、360信息流</span>
					<span>数据效果：总曝光量6000w、点击率4.7%、投资回报率1/30等</span>
					<span>客户需求：获取精准的投资需求用户，提高企业品牌微贷网在网民心中的形象</span>
					<span className='special'>投放方案：</span>
					<span className='special'>1、在360搜索提交精准关键词来获取对投资需求的用户，意向度强烈，转化率高；</span>
					<span>2、360手机助手通过商店内今日热点、小编推荐等优质流量位置，曝光强，流量优质，转化率高。</span>
					<span>效果数据：投资用户数据提升50%、注册量上升70%、新增用户增长240%</span>
					<span className='special'>投放总结：微贷网利用360产品矩阵，全覆盖360pc端和360移动端媒体，再利用360品牌广告进行品牌收口，高转化率，投资回报率极高，同时提高了微</span>
					<span>贷网在360网民的品牌形象；</span>
					<span className='special'>客户评价：用户高度匹配行业需求，投放精准，直达潜在用户，转化效果好，广告位置清晰醒目，后台强大便于数据分析，服务团队专业细致，愿意长期</span>
					<span>合作。</span>
				</div>
				<div className='common-title'>效果展示</div>
				<div className='home-contain text-contain' style={{paddingBottom: '50px'}}>
					<div className='text-center' style={{position: 'relative'}}>
						<img className='mobile-img' src={`${process.env.PUBLIC_URL}/images/mobile-border.png`} />
						<img style={{position: 'absolute', left: '381px', top: '38px'}} src={`${process.env.PUBLIC_URL}/images/mobile-show.png`} />
					</div>
					<span className='second-title'>移动端360助手</span>
					<div className='text-center' style={{position: 'relative'}}>
						<img className='block-center' src={`${process.env.PUBLIC_URL}/images/pc-border.png`} />
						<img style={{position: 'absolute', left: '176px', top: '35px'}} src={`${process.env.PUBLIC_URL}/images/pc-show.png`} />
					</div>
					<span className='second-title'>360搜索</span>
				</div>
			</div>
		)
	}
}
export default Weidai;



// WEBPACK FOOTER //
// ./src/components/examples/weidai.jsx